$(function() {
  var template = $('.template').val();
  var email_pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  
  /* header menu */
  $('.menu-icon').on('click', function(){
    $('#nav-i-menu').addClass('open');
    $('.c-mask').addClass('open');
  });

  $('.currency-drodown .curr-select').on('click', function(){
    $('.currency-list').slideToggle();
  });

  $('.search-icon').on('click', function(){
    $('.search-bar').slideToggle();
  });

  $('#nav-i-menu .sub-title').on('click', function(){
    if ($(this).hasClass('selected')) {
      $(this).removeClass('selected');
      $(this).parent('.level-1').find('ul').slideUp();
    } else {
      $(this).addClass('selected');
      $(this).parent('.level-1').find('ul').slideDown();
    }
    $(this).parent('.level-1').siblings('.level-1').find('.sub-title').removeClass('selected');
    $(this).parent('.level-1').siblings('.level-1').find('ul').slideUp();
  });

  /* currency */
  var cookieCurrency = Currency.cookie.read();

  if (cookieCurrency != null) {
    $('.currency-drodown .curr-select').text(cookieCurrency);
    $('.currency-list li').removeClass('selected');
    $('.currency-list li[value="'+cookieCurrency+'"]').addClass('selected');
  }
  $('.currency-list li').on('click', function(){
    var currency_txt = $(this).text();
    $(this).addClass('selected').siblings('li').removeClass('selected');
    $('.currency-drodown .curr-select').text(currency_txt);
    $('.currency-list').slideUp();
    var value = $(this).attr('value'); 
    $(".currency-picker option[value='"+value+"']").prop("selected", true);
    $('.currency-picker').val(value).trigger('change');
  });


  $('.btn-newsltr').on('click', function(){
    var $form = $(this).parents('form');
    var txtmail = $form.find('.txtmail').val();
    
    if(txtmail == '') {
      $form.find('.err-newsltr').text('Email is required').show();
      $form.find('.txtmail').focus();
      return false;
    }
    
    if(!email_pattern.test(txtmail)){
      $form.find('.err-newsltr').text('Valid email is required').show();
      $form.find('.txtmail').focus();
      return false;
    }
    
    $form.find('.err-newsltr').text('').hide();
    
    $('body').removeClass('email-pop-open');
    $.cookie('gcds_newletter', 1, {expires: 730, path: '/'});
    
  });
  
  // prevent popup to hide on form click
  $('.frm-newltr').on('click', function(e){
    e.stopPropagation();
  });
  
  // hide popup on outside click
  $('body').on('click', function() {
    if($('body').hasClass('email-pop-open')){
        $('body').removeClass('email-pop-open');
       $.cookie('gcds_newletter', 1, {expires: 730, path: '/'});
    }
  });
 
  
  /* Home page */
  if(template == 'index') {

    $(window).on('load',function(){

      // draggable and resizable feature 
      if(!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))){
        $('.drag_img').draggable({
          containment:'parent',
          multiple:true
        });

        $(".resize-img").resizable({
          containment:'#resize_div'
        });
      }

      // draggable and resizable feature 
      if(!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))){
        $('.drag_img_product').draggable({
          containment:'parent',
          multiple:true
        });

        $(".resize-img_product").resizable({
          containment:'#resize_div_product'
        });
      }
      
    });
    /*disable_resize();

    $(window).on('resize', function(){
      disable_resize();
    });*/

    /* First time visit popup */
    var newsltr_cookie = $.cookie('gcds_newletter');
    
    var show_cookie = "true";
  
    var homepopup = $.cookie('gcds_homepopup');
    if(homepopup == null && show_cookie == 'true'){
      $('.acptcookie').addClass('cookie-opened')
    }else{
      showNewsletter(newsltr_cookie);
    }

    $('.acptclose').click(function(){
      $(this).parent('.acptcookie').removeClass('cookie-opened');	
      $.cookie('gcds_homepopup', 1, { expires: 365, path: '/' });  
       showNewsletter(newsltr_cookie);
    });
  }
   /* End first time visit popup */
  /* Home page */
  
  /* Collection page swatch */
  if(template.indexOf('collection') >= 0) {
    $('.collection-swatch input[type="radio"]').on('change', function(){
      $(this).parents('.product-item').find('.product-img .i-loader').show();
      $(this).parents('.product-item').find('.product-img img').attr('src',$(this).attr('data-img'));
    });
    
    $('.product-item .product-img img').on('load', function(){
      $(this).parents('.product-item').find('.product-img .i-loader').hide();
    });
  }
  /* End collection page swatch */
  
  /* Product page */
  if(template == 'product') {
    $('.select-i-box .select-label').on('click', function(event){
         event.stopPropagation();
      $('.pro-qty-var').find('.select-option').not($(this)).slideUp();
      
      if($(this).parent('.select-i-box').find('.select-option').is(':visible')) {
        $(this).parent('.select-i-box').find('.select-option').slideUp();
      }
      else{
        $(this).parent('.select-i-box').find('.select-option').slideDown();
      }
    });

    $('.select-option li').on('click', function(){
      var currency_txt = $(this).text();
      $(this).addClass('selected').siblings('li').removeClass('selected');
      $(this).parents('.select-i-box').find('.select-label').text(currency_txt);
      $(this).parents('.select-i-box').find('.select-option').slideUp();
    });
    /*$('.pro-main-slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: false,
      nextArrow: false,
      asNavFor: '.pro-thumb-slide'
    });*/
    $('.pro-thumb-slide').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
     // asNavFor: '.pro-main-slide',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 4,
          }
        },
      ]
    });
    
    $(document).on('click', '.thumb-img img,.t-slide-img img', function(){ 
       var img_src = $(this).attr('lg-img');
       var alt = $(this).attr('alt');
      /*  if(alt.indexOf("iframe") > 0 ){	
          alt = alt.replace('width','').replace('height','');
          $('.main-pro-img').hide(); 
          $('.main-pro-video').show().html(alt);
        } else {
          $('.main-pro-video').hide();*/
          $('.main-pro-img').attr('src',img_src).show();
       // }
      
    });
	
    $('.select-option').find('li').click(function(){
    	var qty = $(this).attr('value');
        $('#quantity').val(qty);
    });
    
    jQuery(function() {
      jQuery('.swatch :radio').change(function() {
        var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
        var optionValue = jQuery(this).val();
        jQuery(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });
    });
    var currValue = $('.size-option').find('.selected').text();
    $('.size-label').text(currValue);
    
    $('.size-option').find('li').click(function(){ 
      var optionIndex = $(this).closest('.size-option').attr('size-index');
      var optionValue = $(this).attr('value');
      $('.size-label').text(optionValue);
	  $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    });
   
   $('#size-chart-link,.size_chart').on('click', function(){
    $('body').addClass('o-hidden');
    $('.size-chart-popup').addClass('open');
  });
    
  } 
  /* Product page */ 
  
  /* Cart page */
    if(template == 'cart') {
      $('.quantity').on('change' , function(){ console.log('dsfdsf')
      	var qty = $(this).val();
        var variant_id = $(this).attr('data-id');
          $.ajax({  
             type: 'POST',
             url: '/cart/update.js',
     	     data: "updates["+variant_id+"]="+qty,
     		 dataType: 'json',
             success: function(cart) { 
                 window.top.location.href='/cart';
              }
  		  });     
        
      });
    }
  /* End cart page */
  /* Login page */
  $('.btn-login').on('click', function(){
    var $form = $(this).parents('form');
    var txtmail = $form.find('.txtmail').val();
    var txtpwd = $form.find('.txtpwd').val();
    
    if(txtmail == '') {
      $form.find('.err_login').text("Email is required");
      $form.find('.txtmail').focus();
      return false;
    }
    if(!email_pattern.test(txtmail)) {
      $form.find('.err_login').text("Valid email is required");
      $form.find('.txtmail').focus();
      return false;
    }
    if(txtpwd == '') {
      $form.find('.err_login').text("Password is required");
      $form.find('.txtpwd').focus();
      return false;
    }
    $form.find('.err_login').text("");
  });
  
  $('.btn-res_pwd').on('click', function() {
    var $form = $(this).parents('form');
    var txtmail = $form.find('.txtmail').val();
    if(txtmail == '') {
      $form.find('.err_res-pwd').text("Email is required");
      $form.find('.txtmail').focus();
      return false;
    }
    if(!email_pattern.test(txtmail)) {
      $form.find('.err_res-pwd').text("Valid email is required");
      $form.find('.txtmail').focus();
      return false;
    }
    $form.find('.err_res-pwd').text("");
  });
  /* End login page */
  
  /* Register page */
  $('.btn-reg').on('click', function(){
    var $form = $(this).parents('form');
    var txtfname = $form.find('.txtfname').val();
    var txtlname = $form.find('.txtlname').val();
    var txtmail = $form.find('.txtmail').val();
    var txtpwd = $form.find('.txtpwd').val();
    
    if(txtfname == '') {
      $form.find('.err_reg').text("First name is required");
      $form.find('.txtfname').focus();
      return false;
    }
    if(txtlname == '') {
      $form.find('.err_reg').text("Last name is required");
      $form.find('.txtlname').focus();
      return false;
    }
    if(txtmail == '') {
      $form.find('.err_reg').text("Email is required");
      $form.find('.txtmail').focus();
      return false;
    }
    if(!email_pattern.test(txtmail)) {
      $form.find('.err_reg').text("Valid email is required");
      $form.find('.txtmail').focus();
      return false;
    }
    if(txtpwd == '') {
      $form.find('.err_reg').text("Password is required");
      $form.find('.txtpwd').focus();
      return false;
    }
    $form.find('.err_reg').text("");
  });
  /* End register page */
  
  /* account page */
   $('.account-tab ul li').on('click', function(){
      $(this).addClass('active').siblings('li').removeClass('active');
      $('#'+$(this).find('a').attr('data-link')).removeClass('hide').siblings('.ac-tab-content').addClass('hide');
    });

    $('.change_pwd').on('click',function(){
      $('.change_pwd_div').show();
      $(this).hide();
    });
  
    $('.change_pwd_div .cancle').on('click',function(){
      $('.change_pwd_div').hide();
      $('.change_pwd').show();
    });

    $('.btn-resetpwd').click(function(){
      var $form = $(this).parents('form');
      var txtemail = $form.find('.txtemail').val();
      var emailregex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if(txtemail == ''){
        $form.find('.error-reset').text('Email is required').show();
        $form.find('.txtemail').focus();
        return false;
      }
      else if(!txtemail.match(emailregex)){
        $form.find('.error-reset').text('Valid email is required').show();
        $form.find('.txtemail').focus();
        return false;
      }
      else {
        $form.find('.error-reset').text('').hide();
      }
    });
    /* End account page */
  
  /* address page */
   $('.btn_address').on("click", function(){
      var $form = $(this).parents('.address-form');
      var txtfname = $form.find('.txtfname').val();
      var txtlname = $form.find('.txtlname').val();
      var txtcmp = $form.find('.txtcmp').val();
      var txtaddr1 = $form.find('.txtaddr1').val();
      var txtaddr2 = $form.find('.txtaddr2').val();
      var txtcity = $form.find('.txtcity').val();
      var selcountry = $form.find('.selcountry').val();
      var txtzip = $form.find('.txtzip').val();
      var txtphone = $form.find('.txtphone').val();

      var error = [];

      $form.find('.form-error').hide();

      if(txtfname == '') {
        error.push('txtfname');
      }
      else if(txtlname == '') {
        error.push('txtlname');
      }
      else if(txtcmp == '') {
        error.push('txtcmp');
      }
      else if(txtaddr1 == '') {
        error.push('txtaddr1');
      }
      else  if(txtaddr2 == '') {
        error.push('txtaddr2');
      }
      else  if(txtcity == '') {
        error.push('txtcity');
      }
      else if(selcountry == '---') {
        error.push('selcountry');
      }
      else if(txtzip == '') {
        error.push('txtzip');
      }
      else if(txtphone == '') {
        error.push('txtphone');
      }

      if(error.length > 0) {
        var errorMsg = '';

        if(error[0] == 'address_country_new') {
          errorMsg = 'Please select country';
        }
        else {
          errorMsg = 'This field is required';
        }
        $form.find('.err-'+error[0]).text(errorMsg).show();
        $form.find('.'+error[0]).focus();
        return false;
      }
      else {
        $form.find('.form-error').hide();
        $(this).parents('form').submit();
        return true;
      }
    });
  /* End address page */
  
  /* account activate page */
   $('.acc_btn').on('click', function() {
       var form = $(this).parents('form');
       var password=$('#customer_password').val();
       var c_passwd = $('#customer_password_confirmation').val();
     
       form.find('.form-error').hide();
       if(password == ''){
           form.find('.txtpasswd_error').text("Require Password field.").show(); 
           return false;
        }
       else if(c_passwd == ''){
           form.find('.txtrpasswd_error').text("Require this field.").show();
           return false;
        } 
       else if(password.length < 5) {
         form.find('.txtpasswd_error').text("The password field is too short (minimum is 5 characters).").show(); 
           return false;
        }
        else if(password != c_passwd ){
         form.find('.txtrpasswd_error').text("Password do not match.").show();
             return false;
        }
       else {
        return true;
      }
  });
  /* end account activate page */
  
  /* reset password page */
   $('.reset_btn').on('click', function() {
       var form = $(this).parents('form');
       var password=$('#reset_password').val();
       var c_passwd = $('#password_confirmation').val();
     
       form.find('.error').hide();
       if(password == ''){
           form.find('.error').text("Require password field.").show(); 
           return false;
        }
       else if(c_passwd == ''){
           form.find('.error').text("Require confirm password field.").show();
           return false;
        } 
       else if(password.length < 5) {
         form.find('.error').text("The password field is too short (minimum is 5 characters).").show(); 
           return false;
        }
        else if(password != c_passwd ){
         form.find('.error').text("Password do not match.").show();
             return false;
        }
       else {
        return true;
      }
  });
  /* end reset password page */
  
}); 

// Disable draggable and resizable on mobile & tablet 
function disable_resize() {
  if($(window).width() < 1024) {
    $('.drag_img').draggable({disabled:true});
    $('.resize-img').resizable({disabled:true});
  }
  else {
    $('.drag_img').draggable({disabled:false});
    $('.resize-img').resizable({disabled:false});
  }
}

var show_newsltr = "false";

function showNewsletter(newsltr_cookie){
  if(show_newsltr == 'true') {
    if(newsltr_cookie == null || typeof newsltr_cookie == 'undefined' ) {
      setTimeout(function(){
        $('body').addClass('email-pop-open');
      },1000);
    }
  }
}
// Close navbar

function closeNav(){
  $('#nav-i-menu').removeClass('open');
  $('.c-mask').removeClass('open');
}
$(document).on("click", function () {
   $('.select-i-box').find('.select-option').slideUp();
});

// Close size popup
$('.size-chart-popup, .popup-box .close-ic').on('click', function(){
  $('body').removeClass('o-hidden');
  $('.size-chart-popup').removeClass('open');
});

$('.popup-box').on('click', function(event){
  event.stopPropagation();
});

